module.exports = __webpack_public_path__ + "static/img/023 4.a7ef57c2.jpg";